import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8263cea2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flexBox" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "售前咨询热线", -1))
const _hoisted_3 = { class: "phone" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "phone-text" }, "15728562024", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "扫码添加顾问微信", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        class: "phone-icon",
        src: require('@/assets/images/consult/service.png')
      }, null, 8, _hoisted_4),
      _hoisted_5
    ]),
    _createElementVNode("img", {
      class: "qrCode",
      src: require('@/assets/images/workerCode250212.png')
    }, null, 8, _hoisted_6),
    _hoisted_7
  ]))
}